<template>
    <div class="text-center">
        <v-pagination
        v-model="page.page"
        :length="page.length"
        :total-visible="7"
        ></v-pagination>
    </div>
</template>

<script>
export default {
    name: 'CoursePagination',
    props: ['page'],
}
</script>